"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbBreadcrumb = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sbLink = require("../sb-link/sb-link");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @namespace skybase-components.sb-breadcrumb
 *
 * @public
 *
 * @class
 * @classdesc
 * Page breadcrumb component.
 *
 */
var SbBreadcrumb = function SbBreadcrumb(props) {
  /**
   * @desc
   * Returns calculated class names based on given props.
   *
   * @private
   * @function
   *
   * @param {object}  className - Props passed to this component.
   */
  var getClassNames = function getClassNames(className) {
    return (0, _classnames.default)('sb-breadcrumb-wrapper', className);
  };
  /**
   * @desc
   * Renders given parts.
   *
   * @private
   * @function
   *
   * @param   {Array}   parts   - Array of strings with paths.
   * @returns {Array}   *       - Array of generated react components.
   */


  var renderParts = function renderParts(parts) {
    return parts.map(function (part, index) {
      var key = "breadcrumb-item-".concat(index);

      if (typeof part === 'string') {
        return /*#__PURE__*/_react.default.createElement("span", {
          key: key,
          className: "breadcrumb-item"
        }, part);
      }

      var title = part.title,
          path = part.path,
          id = part.id,
          className = part.className,
          partStyle = part.style;

      if (!path) {
        return /*#__PURE__*/_react.default.createElement("span", {
          key: key,
          className: (0, _classnames.default)('breadcrumb-item', className),
          id: id,
          style: partStyle
        }, title);
      }

      return /*#__PURE__*/_react.default.createElement(_sbLink.SbLink, {
        to: path,
        key: key,
        className: (0, _classnames.default)('breadcrumb-item', className),
        id: id
      }, title); // return breadcrumb
    });
  };

  var className = props.className,
      id = props.id,
      style = props.style;
  var classNames = getClassNames(className);
  var parts = props.parts;
  parts = parts ? (0, _isArray.default)(parts) ? parts : [parts] : []; // eslint-disable-line

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classNames,
    id: id,
    style: style,
    role: "navigation",
    "aria-label": "Breadcrumbs"
  }, renderParts(parts));
};

exports.SbBreadcrumb = SbBreadcrumb;
SbBreadcrumb.propTypes = {
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  parts: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    id: _propTypes.default.string,
    className: _propTypes.default.string,
    path: _propTypes.default.string,
    title: _propTypes.default.string.isRequired,
    style: _propTypes.default.object
  })])),
  style: _propTypes.default.object // eslint-disable-line

};
SbBreadcrumb.defaultProps = {
  className: null,
  id: null,
  parts: [''],
  style: null
};
//# sourceMappingURL=sb-breadcrumb.js.map